import React from 'react';
import { Container } from 'react-bootstrap';

const Map = () => {
  return (
    <section id="map" className="py-5">
      <Container>
        <iframe
          title="Hotel Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d679.2460158108769!2d22.31260300633141!3d52.79654495332406!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471fa377a8073723%3A0x30db5a729d76ceca!2sLewiatan!5e0!3m2!1spl!2spl!4v1730537474733!5m2!1spl!2spl"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </Container>
    </section>
  );
};

export default Map;


